module.exports = __webpack_public_path__ + "img/6.3e5bfb62.png";